import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { Subscription } from 'rxjs-compat';
import { SelectSupplierChannelList } from 'app/profile/store/app.selector';
import { AutoInvoiceSupplierSourceMap, SupplierChannelPropertyValues } from 'app/profile/models/supplier.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ChannelSourceMapEnum, ChannelValidationStatus, EMEAEUREGIONS, Region } from '../einvoicing.constants';
import { EInvoicingService, ValidationError, FileValidationResult } from 'app/profile/services/einvoicing-channels.service';
import { ChannelTemplateConfig, ChannelValidationRequest, EdiVanInformation, RegionChannels, SupplierChannelValidationRequest, TemaplateDocumentConfig, ValidationFileInfo, ValidationRequest, ValidationRequestComment } from 'app/profile/models/channels.model';
import { Observable } from 'rxjs/Observable';
import { AuthData } from '@tesla/ng-auth';
import { FileUploadService } from 'app/common/services/fileUpload.service';
import { TslCheckboxChange, TslDialog, TslFileDrop } from '@tesla/ng-tds';
import * as FileSaver from 'file-saver';
import { forkJoin } from 'rxjs';
import { stringify } from 'querystring';
import { map } from 'rxjs/operators';
import { I18nService } from 'app/shared/services/i18n.service';
import { AppSettings } from '../../../../app.settings';
import { LanguageService } from '../../../../core/services/language.service';

@Component({
  selector: 'app-channel-onboarding',
  templateUrl: './channel-onboarding.component.html',
  styleUrls: ['./channel-onboarding.component.scss']
})
export class ChannelOnboardingComponent implements OnInit, OnDestroy {

  code: string = '';
  subscription: Subscription = new Subscription;
  supplierChannels: SupplierChannelPropertyValues[] = [];

  createChannelRequestFormGroup: FormGroup;
  region: FormControl = new FormControl('', Validators.required);
  entity: FormControl = new FormControl('', Validators.required);
  channelSelection: FormControl = new FormControl('',  [Validators.required, this.channelsValidator.bind(this)],this.ediVANValidation.bind(this));
  comments: FormControl = new FormControl('', Validators.required);

  ediVANInformationForm: FormGroup;
  ediQualifierTest: FormControl = new FormControl('');
  ediQualifierProd: FormControl = new FormControl('');
  ediVanProvider: FormControl = new FormControl('');
  ediBusCont: FormControl = new FormControl('');

  loading: boolean = true;

  filteredEntities: string[];
  filteredRegions: string[];

  isEDISelected : boolean = false;
  supplierConfirmation: boolean = false;

  currentChannelOptions : string[] = [];
  isChannelSelection : boolean = true;

  openRequests: Array<ChannelValidationRequest>;  //holds all the open requests for a supplier id
  selectionMessage: string = ''; //Message to show if there is an open request/there isn't an open request

  openRequest: boolean = false;

  ediVANInformation: EdiVanInformation;

  loadedFiles: File[] = [];
  fileDropVisible: boolean = true;
  currentUserEmail: string;
  validationRequest: ValidationRequest = new ValidationRequest;

  channelSelected: boolean = false;
  allowDownload: boolean = false;
  allowDownloadError: string = '';

  channelTemplateConfig: ChannelTemplateConfig[];
  selectedChannelTemplate: TemaplateDocumentConfig[];

  channelTemp: string = '';
  changed: boolean = false;

  validationErrors: ValidationError[] = [];
  isValidating: boolean = false;
  showValidationErrors: boolean = false;

  guidelineUrl = '';
  createInvoiceFromPOUrl = '';

  languageId = '';

  @Output() onComplete: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('fileDrop', {static: false}) fileDrop: TslFileDrop;

  constructor(
    private route: ActivatedRoute,
    private store: Store<SupplierState>,
    private eInvoicingService: EInvoicingService,
    private authData: AuthData,
    private fileUploadService: FileUploadService,
    private dialog: TslDialog,
    private translate: I18nService,
    private config: AppSettings,
    private languageService: LanguageService,
  ) {
    this.openRequests = new Array<ChannelValidationRequest>();
    this.currentUserEmail = authData.getUserInfo().email;
    this.languageId = this.languageService.getSelectedLanguage()
    this.guidelineUrl = `${this.config.PUBLIC_URL}/documents`;
    this.createInvoiceFromPOUrl = `${this.config.PUBLIC_URL}/procuretopay/${this.languageId}/invoices/create/indirect`;
  }

  ngOnInit(): void {

    let supplierCodSub = this.route.parent.params.subscribe((params) => {
      if(!params['code']){
        return;
      }
      this.code = params['code'];

      let channelListSub = this.store.pipe(select(SelectSupplierChannelList)).subscribe((channelList) => {

        if(!channelList){
          return;
        }
        this.supplierChannels = channelList;
        this.filteredEntities = this.entityList;
        this.filteredRegions = this.regionList;
        this.loading = false;
      });
      this.subscription.add(channelListSub);
    });
    this.subscription.add(supplierCodSub);

    this.createChannelRequestFormGroup = new FormGroup({
      region: this.region,
      entity: this.entity,
      channel: this.channelSelection,
      comments: this.comments
    });

    this.ediVANInformationForm = new FormGroup({
      ediQualifierTest: this.ediQualifierTest,
      ediQualifierProd: this.ediQualifierProd,
      ediVanProvider: this.ediVanProvider,
      ediBusCont: this.ediBusCont
    });

    let templates = this.eInvoicingService.getChannelTemplates()
    .subscribe((teamplateConfig: ChannelTemplateConfig[]) => {
      if(!teamplateConfig){
        return;
      }

      this.channelTemplateConfig = teamplateConfig;
    });

    this.subscription.add(templates);
  }

  //Gets regions for form selection initial value
  get regionList(): string[]{
    let regions = [];
    //Adds a generic 'All' for the region selection
    regions.push('All');
    this.supplierChannels.forEach( (element) => {
      if(element.region.newValue && !regions.includes(element.region.newValue)){
        regions.push(element.region.newValue);
      }
    });
    return regions;
  }

  //Gets entity list for form entity selection initial value
  get entityList(): string[]{
    let entities = [];

    this.supplierChannels.forEach((element) =>{
      entities.push(element.entityName.newValue);
    });
    return entities;
  }

  get getAcceptedFormat() {
    return ".pdf,.txt,.csv,.xml";
  }

  get requiredFileType(){
    switch(this.channelSelection.value){
      case ChannelSourceMapEnum[ChannelSourceMapEnum.EDI]:
        return ".txt";
      case ChannelSourceMapEnum[ChannelSourceMapEnum.PortalCSV]:
        return ".csv";
      case ChannelSourceMapEnum[ChannelSourceMapEnum.CXML]:
        return ".xml";
      default:
        return "";
    }
  }

   getChannels(): void{

    if(!this.region.value || this.region.value == 'All'){
      this.currentChannelOptions = [];
      this.isChannelSelection = true;
    }else{
      var entityChannels = this.validChannels(this.supplierChannels.find(x => x.entityName.newValue == this.entity.value)?.sources.newValue);
      this.currentChannelOptions = [];
      entityChannels.forEach(x => {
        this.currentChannelOptions.push(x.SourceName)
      });
    }
  }

  onRegionChange(event){
    this.changed = true;

    this.channelSelection.reset();
    this.channelSelected = false;
    this.channelTemp = '';
    if(this.isEDISelected){
      this.ediVANInformationForm.reset();
    }
    this.isEDISelected = false;
    this.selectedChannelTemplate = this.getTemplatesForChannel('');

    if(event.value === 'All'){
      this.entity.reset();
      this.filteredEntities = this.entityList;
    }else{
      this.setFilteredEntities();
    }

    this.channelSelection.disable();
  }

  async onEntityChange(event){
    this.changed = true;
    let entityRecord = this.supplierChannels.find(entity => entity.entityName.newValue == event.value);
    if(!this.region.value || this.region.value !== entityRecord.region.newValue){
      this.region.setValue(entityRecord.region.newValue);
      this.setFilteredEntities();
    }

    this.channelSelection.reset();
    this.channelSelected = false;
    this.channelTemp = '';
    if(this.isEDISelected){
      this.ediVANInformationForm.reset();
    }
    this.isEDISelected = false;
    this.selectedChannelTemplate = this.getTemplatesForChannel('');
    this.getChannels();
    this.channelSelection.enable();

    this.validationRequest.SupplierID = entityRecord.supplierId.newValue;
    this.validationRequest.EntityName = entityRecord.entityName.newValue;
    this.getChannelValidationRequests(entityRecord.supplierId.newValue);

  }

  onSupplierConfirmationSelfBillingChange(event: TslCheckboxChange){
    this.supplierConfirmation = event.checked;
  }

  setFilteredEntities(): void{
    this.filteredEntities = this.supplierChannels.filter(entity => entity.region.newValue === this.region.value).map( (element) => {
      return  element.entityName.newValue;
    });
  }

  validChannels(supplierChannels: AutoInvoiceSupplierSourceMap[]): {SourceName: string, Enabled: boolean, Supplierid: number}[] {
    const sources : {SourceName: string, Enabled: boolean, Supplierid: number}[] = []

    return this.eInvoicingService.validChannelsForChannelSelection(supplierChannels);
  }

  onChannelChange(event){
    this.changed = true;
    this.validationRequest.AutoInvoiceSupplierSourceID = Number(ChannelSourceMapEnum[this.channelSelection.value]);
    this.channelTemp = this.channelSelection.value.toUpperCase();

    if(EMEAEUREGIONS.includes(this.region.value)){
      this.channelTemp = this.channelTemp + 'EMEA'
    }

    this.selectedChannelTemplate = this.getTemplatesForChannel(this.channelTemp);
    this.channelSelected = true;
    this.allowDownload = true;
    this.allowDownloadError = '';

    this.showValidationErrors = false;
    this.validationErrors = [];

    if(this.channelSelection.value == ChannelSourceMapEnum[ChannelSourceMapEnum.SelfBilling]){
      this.resetFiles();
    }
  }

  getChannelValidationRequests(supplierid : number){
    let openChannelRequestsSub = this.eInvoicingService.getSupplierIDOpenChannleRequests(supplierid)
      .subscribe((openRequests : Array<ChannelValidationRequest>) =>{
        this.openRequests = openRequests;
      });
    this.subscription.add(openChannelRequestsSub);
  }


  removeFile(index) {
    this.loadedFiles.splice(index, 1);
    this.fileDropVisible = true;

    this.showValidationErrors = false;
    this.validationErrors = [];
  }

  onFileAdd(files: File[]) {
    this.changed = true;
    if(!files.length) {
      this.loadedFiles = [];
    } else {
      let newFiles = files.slice(0, 5);
      this.loadedFiles = [...this.loadedFiles, ...newFiles];
    }

    this.showValidationErrors = false;
    this.validationErrors = [];
  }

  resetFiles() {
    this.fileDrop.reset(true);

    this.showValidationErrors = false;
    this.validationErrors = [];
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  downlodChannelTemplates(documentId: string, fileName: string) {
    if(this.allowDownload){
      this.eInvoicingService.downloadTemplate(documentId).subscribe( resultBolb => {
        FileSaver.saveAs(resultBolb, fileName);
      });
    }else{
      this.allowDownloadError = this.translate.get('Please first select a channel and an entity');
    }
  }

  clear(): void{
    this.createChannelRequestFormGroup.reset();
    if(this.fileDrop && this.loadedFiles){
      this.resetFiles();
    }
    this.channelSelected = false;
    this.channelTemp = '';

    if(this.isEDISelected){
      this.ediVANInformationForm.reset();
    }
    this.filteredEntities = this.entityList;

    this.isChannelSelection = true;

    this.isEDISelected = false;
    this.changed = false;
    this.selectedChannelTemplate = this.getTemplatesForChannel('');
    this.currentChannelOptions = [];
    this.supplierConfirmation = false;

    this.showValidationErrors = false;
    this.validationErrors = [];
  }

  onSubmit(): void{
    if(!this.createChannelRequestFormGroup.valid ||
      (this.loadedFiles?.length <= 0 && this.channelSelection?.value != 'SelfBilling') ||
      (this.channelSelection?.value == 'SelfBilling' && !this.supplierConfirmation)){
      return;
    }

    if(this.channelSelection.value != ChannelSourceMapEnum[ChannelSourceMapEnum.SelfBilling] && this.loadedFiles?.length > 0){
      const fileSelector = (f: File) => f.name.toLocaleLowerCase().endsWith(this.requiredFileType);
      const requiredFileCheck = this.loadedFiles?.filter((f: File) => fileSelector(f));

      if(requiredFileCheck?.length == 0){
        this.dialog.alert(this.translate.get('Alert'), this.translate.get('You did not upload the required file type. The required file type for this channel is ') + this.requiredFileType, this.translate.get('OK'));
        return;
      }
    }

    this.validationErrors = [];
    this.showValidationErrors = false;

    if (this.loadedFiles?.length > 0 && this.channelSelection?.value === 'CXML') {
      this.isValidating = true;

      this.eInvoicingService.validateCXMLFiles(
        this.code,
        this.loadedFiles,
        this.channelSelection.value,
        this.region.value
      ).subscribe(
        (results: FileValidationResult[]) => {
          this.isValidating = false;

          const invalidFiles = results.filter(result => !result.isValid);

          if (invalidFiles.length > 0) {
            this.validationErrors = invalidFiles.map(invalidFile => {
              const errorMessages = invalidFile.errorMessages && invalidFile.errorMessages.length > 0
                ? invalidFile.errorMessages
                : ['Validation failed with unspecified errors.'];
              return {
                fileName: invalidFile.fileName,
                errorMessages: errorMessages,
                // The simplest way to check if there is an ambiguous error is to check
                // if any of the error messages contain the word "exception" or "unexpected".
                // Because it would be tedious to check each 'if' branches on backend (which are pretty a lot)
                // and determine if it is ambiguous or not.
                isAmbiguousError: errorMessages.find(x =>
                  x?.toLowerCase().includes('exception') || x?.toLowerCase().includes('unexpected')) !== undefined,
              }
            });
            this.showValidationErrors = true;
          } else {
            this.continueWithSubmission();
          }
        },
        (error) => {
          this.isValidating = false;
          console.error('CXML Validation API Error:', error);
          this.dialog.alert(
            this.translate.get('Error'),
            this.translate.get('Failed to validate files. Please check the API connection and try again.'),
            this.translate.get('OK')
          );
        }
      );
    } else {
      this.continueWithSubmission();
    }
  }

  private continueWithSubmission(): void {
    let request = new SupplierChannelValidationRequest();
    let validationRequest = this.validationRequest;
    validationRequest.EDIDocumentTypeID = 3;
    validationRequest.CreatedBy = this.currentUserEmail;
    validationRequest.CreatedOn = new Date();
    validationRequest.SupplierCode = this.code;
    validationRequest.Status = ChannelValidationStatus[ChannelValidationStatus.New];
    validationRequest.IsArchived = 0;
    validationRequest.EntityName = this.entity.value;
    request.ValidationRequest = validationRequest;

    let validationRequestComment: ValidationRequestComment = new ValidationRequestComment();
    validationRequestComment.Comment = this.comments.value ? this.comments.value: '';
    validationRequestComment.CreatedBy = this.currentUserEmail;
    validationRequestComment.CreatedOn = new Date();
    request.ValidationRequestComment = validationRequestComment;

    if(this.loadedFiles?.length> 0){
      let fileUploadSub = this.fileUploadService.uploadFilesToServer(this.loadedFiles, this.code, { 'DocumentType': 'EInvoicing_Channel_Request' })
        .pipe(map( (response : {documentID: string, fileName: string}[]) => {
          return response.map( fileData => {
            let file = new ValidationFileInfo();
            file.FilePath = fileData['documentID'] || fileData.documentID;
            file.CreatedOn = new Date();
            file.FileName = this.getFormattedDate(file.CreatedOn).concat(fileData['fileName'] || fileData.fileName);
            file.CreatedBy = this.currentUserEmail;
            file.Status = ChannelValidationStatus[ChannelValidationStatus.New];
            return file;
          })
        })).subscribe(
          (response: ValidationFileInfo[]) => {
            request.ValidationFileInfo = response
            this.CreateChannelValidationRequest(this.code, request);
          }
        );
      this.subscription.add(fileUploadSub);
    } else {
      this.CreateChannelValidationRequest(this.code, request);
    }
  }

  CreateChannelValidationRequest(supplierCode: string, request:  SupplierChannelValidationRequest){

    let newRequest = this.eInvoicingService.postNewChannelValidationRequest(supplierCode, request).subscribe(
      (response) =>{
        this.clear();
        this.changed = false;
        this.loadedFiles = []
        this.dialog.alert(this.translate.get('Alert'), this.translate.get('Channel request was created successfully!'), this.translate.get('OK'));
        this.onComplete.emit();
      });

    this.subscription.add(newRequest);
  }

  channelsValidator(control: FormControl): {[s: string] :boolean} {
    if(this.openRequests?.findIndex(x => x.autoInvoiceSupplierSourceID == Number(ChannelSourceMapEnum[this.channelSelection.value])) >= 0){
      this.selectionMessage = this.translate.get('There is already an open request for this channel. Please select different channel.');
      return {'openRequestExists': true};
    }

    if(this.supplierChannels){
      let entityRecord = this.supplierChannels.find(entity => entity.entityName.newValue == this.entity.value);
      if(entityRecord?.sources?.newValue.findIndex(
          x => x.AutoInvoiceSupplierSourceID == Number(ChannelSourceMapEnum[this.channelSelection.value]) && x.Enabled == true) >= 0){
        this.selectionMessage = this.translate.get('Selected channel is already enabled for this entity. You cannot submit a new request.');
        return {'openRequestExists': true}
      }
    }

    this.selectionMessage = '';
    return null;
  }

  ediVANValidation(control: FormControl): Promise<any> | Observable<any>{
    const promise = new Promise<any>((resolve, reject) =>{
      if(control.value != ChannelSourceMapEnum[ChannelSourceMapEnum.EDI] && control.value != ChannelSourceMapEnum[ChannelSourceMapEnum.SelfBilling]){
        this.isEDISelected = false;
        if(this.createChannelRequestFormGroup.get('edi')){
          this.createChannelRequestFormGroup.removeControl('edi');
        }
        resolve(null);
      }else{
        let sub = this.eInvoicingService.getSupplierEDIVANInfo(this.code).subscribe( result => {
          if(result && result.length > 0){
            this.ediVANInformation = result[0];
            this.ediQualifierProd.setValue(this.ediVANInformation.qualifierProductionID);
            this.ediQualifierTest.setValue(this.ediVANInformation.qualifierTestID);
            this.ediVanProvider.setValue(this.ediVANInformation.vanProvider);
            this.ediBusCont.setValue(this.ediVANInformation.teslaContact);
            this.isEDISelected = true;
            resolve(null);
          }else{
            this.selectionMessage = this.translate.get('Please complete the EDI setup with TeslaEDI@tesla.com prior to submitting the EDI 810 sample.');
            resolve({'missingEDIVANInformation' : true});
          }
        })
      }
    });

    return promise;
  }

  getTemplatesForChannel(templateName: string): TemaplateDocumentConfig[]{
    if(this.channelTemplateConfig){
      let templates = this.channelTemplateConfig.find(x =>
        {
          return x.templateName === templateName
        });

        if(templates){
          return templates.documentsConfig;
        }

      return [];
    }
    return [];
  }

  /** Formats date to MM/dd/yyyy */
  private getFormattedDate(dateInput: Date | string) {
    let date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    let year = date.getFullYear();

    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    let day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;

    return month + '/' + day + '/' + year;
  }
}
